// var apiUrl = "https://api.02you.cn/";
// var apiUrl = "https://api.15you.cn/";
// var apiUrl = "http://api-v2.02you.cn/";
// var apiUrl = "http://127.0.0.1:20300/";
var apiUrl = "https://api.youlingplay.cn/apiV2/";
// var apiUrl = "http://127.0.0.1:23300/apiV2/";
// 获取指定的URL参数值
function getQueryString(name) {
  if (name == 'code') {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  } else {
    if (window.location.hash && window.location.hash.indexOf("?") > -1) {
      var idx = window.location.hash.indexOf("?");
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.hash.substr(idx + 1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    } else {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    }
  }
}

function getModel(msg, str) {
  for (var i in msg) {
    if (msg[i].indexOf(str) > 0) {
      return i;
    }
  }
  return -1;
}

function formDate(time) { //根据时间戳生成的时间对象
  let date = new Date(time);
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var d = date.getDate()
  var str = year + '-' + month + '-' + d
  return str
}

function formDate2(time) { //根据时间戳生成的时间对象
  let date = new Date(time);
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var d = date.getDate()
  var hours = date.getHours()
  hours = hours >= 10 ? hours : "0" + hours
  var minute = date.getMinutes()
  minute = minute >= 10 ? minute : "0" + minute
  var second = date.getSeconds()
  second = second >= 10 ? second : "0" + second
  var str = year + '-' + month + '-' + d + ' ' + hours + '-' + minute + '-' + second
  return str
}

function isChinese(s) {
  return /[\u4e00-\u9fa5]/.test(s);
}

function ch2Unicdoe(str) {
  if (!str) {
    return;
  }
  var unicode = "";
  for (var i = 0; i < str.length; i++) {
    var temp = str.charAt(i);
    if (isChinese(temp)) {
      unicode += "\\u" + temp.charCodeAt(0).toString(16);
    } else {
      unicode += temp;
    }
  }
  return unicode;
}
 // 判断是否在微信内
function isWeixn() {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}
//获取可视区宽高--适配
function getSize() {
  var _this = this;
  let root = document.documentElement;
  let clientWidth = root.clientWidth; //获取客户端宽度
  let clientHeight = root.clientHeight; //获取客户端宽度
  let k = root.clientWidth > root.clientHeight ? 1334 : 750;
  //如果是移动端
  if (
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
  ) {
    root.style.width = "";
    var size = window.getComputedStyle(
      document.getElementsByTagName("html")[0]
    ).fontSize;
    if (
      size &&
      isWeixn() &&
      _this.model == " COLAL10 "
    ) {
      var size = size.split("p")[0];
      if (size * 1.2 < 100 * (clientWidth / k)) {
        //如果当前html的font-size 的1.2倍仍然小于 之前想设置的值，就说明是问题机型，给之前想附的值乘1.25倍，这样他会被系统再次除1.25得到的才是我们想附的值
        root.style.fontSize = 125 * (clientWidth / k) + "px";
      }
    } else if (
      clientWidth / clientHeight >= 0.75 &&
      clientWidth / clientHeight <= 1 &&
      clientWidth > 600
    ) {
      root.style.fontSize = 100 * (clientWidth / k / 2) + "px";
    } else if (
      clientWidth / clientHeight > 1 &&
      clientWidth / clientHeight <= 1.4 &&
      clientWidth < 750
    ) {
      root.style.fontSize = 100 * (clientWidth / 750 / 1) + "px";
    } else if (
      clientWidth / clientHeight > 2.4 &&
      clientWidth / clientHeight < 3
    ) {
      root.style.fontSize = 100 * (clientWidth / k / 1.2) + "px";
    } else if (clientWidth / clientHeight > 3) {
      root.style.fontSize = 100 * (clientWidth / k / 1.4) + "px";
    } else {
      root.style.fontSize = 100 * (clientWidth / k) + "px";
    }
  } else if (
    clientWidth / clientHeight > 0.65 &&
    clientWidth / clientHeight <= 1
  ) {
    root.style.fontSize = 100 * (clientWidth / k / 1.5) + "px";
  } else if (
    clientWidth / clientHeight &&
    clientWidth > 900 &&
    clientWidth < 1180
  ) {
    root.style.fontSize = 100 * (clientWidth / k / 1.6) + "px";
  } else if (clientWidth >= 1180 && clientWidth < 1480) {
    root.style.fontSize = 100 * (clientWidth / k / 2) + "px";
  } else if (clientWidth >= 1480) {
    root.style.fontSize = 100 * (clientWidth / k / 2.5) + "px";
  } else {
    clientWidth = clientWidth > 900 ? 900 : clientWidth;
    root.style.fontSize = 100 * (clientWidth / k) + "px";
  }
}
 //根据屏幕宽和高获取iframe高度
function h5_screen_orientation() {
  let gameSize={};
  if (localStorage.getItem("deskIcon") && window.screen.availHeight) {
    // this.m_h =
    //   window.screen.availHeight ||
    //   window.innerHeight ||
    //   document.documentElement.clientHeight;

    gameSize.m_h = window.innerHeight || document.documentElement.offsetHeight;

  } else {
    gameSize.m_h = window.innerHeight || document.documentElement.clientHeight;
  }
  gameSize.m_w = window.innerWidth || document.documentElement.clientWidth;
  return gameSize;
}
export default {
  getQueryString,
  apiUrl,
  getModel,
  formDate,
  formDate2,
  ch2Unicdoe,getSize,
  h5_screen_orientation
}



// WEBPACK FOOTER //
// ./src/common/js/common.js